/**
 * Team page: when intro section bottom meets viewport bottom, pin the section;
 * further scroll scrubs SplitText dim → white per character.
 */

(function() {
	'use strict';

	var DIM = 'rgba(255, 255, 255, 0.3)';
	var LIT = '#ffffff';
	// Lower = letters reach white earlier within the same pin progress (less “tail” after fill).
	var DESC_FILL_END = 0.4;
	// Pin scroll distance = innerHeight * (PIN_SCROLL_VH / 100). Smaller = less wheel travel.
	var PIN_SCROLL_VH = 200;
	var initAttempts = 0;
	var maxInitAttempts = 50;

	function getScrollTrigger() {
		if (typeof gsap !== 'undefined' && gsap.ScrollTrigger) {
			return gsap.ScrollTrigger;
		}
		if (typeof window !== 'undefined' && window.ScrollTrigger) {
			return window.ScrollTrigger;
		}
		if (typeof ScrollTrigger !== 'undefined') {
			return ScrollTrigger;
		}
		if (typeof gsap !== 'undefined' && gsap.plugins && gsap.plugins.ScrollTrigger) {
			return gsap.plugins.ScrollTrigger;
		}
		return null;
	}

	function getSplitText() {
		if (typeof window !== 'undefined' && window.SplitText) {
			return window.SplitText;
		}
		if (typeof SplitText !== 'undefined') {
			return SplitText;
		}
		return null;
	}

	function prefersReducedMotion() {
		return typeof window !== 'undefined' &&
			window.matchMedia &&
			window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function applyCharColors(chars, progress) {
		var len = chars.length;
		if (!len) {
			return;
		}
		var t = progress * len;
		for (var i = 0; i < len; i++) {
			chars[i].style.color = i < t ? LIT : DIM;
		}
	}

	function fillProgressFromScrollProgress(scrollProgress) {
		if (scrollProgress <= 0) {
			return 0;
		}
		if (scrollProgress >= 1) {
			return 1;
		}
		var scaled = scrollProgress / DESC_FILL_END;
		return scaled > 1 ? 1 : scaled;
	}

	function initTeamDescriptionReveal() {
		var root = document.querySelector('.page-team');
		var introSection = root ? root.querySelector('.page-team__stack-layer--intro') : null;
		var scene = root ? root.querySelector('.page-team__intro-description') : null;
		var textEl = scene ? scene.querySelector('.page-team__description-text') : null;

		if (!root || !introSection || !scene || !textEl) {
			return;
		}

		if (prefersReducedMotion()) {
			textEl.style.color = LIT;
			return;
		}

		if (typeof gsap === 'undefined') {
			initAttempts++;
			if (initAttempts < maxInitAttempts) {
				setTimeout(initTeamDescriptionReveal, 100);
			}
			return;
		}

		var ScrollTriggerPlugin = getScrollTrigger();
		if (!ScrollTriggerPlugin || typeof ScrollTriggerPlugin.create !== 'function') {
			initAttempts++;
			if (initAttempts < maxInitAttempts) {
				setTimeout(initTeamDescriptionReveal, 100);
			}
			return;
		}

		var SplitTextCtor = getSplitText();
		if (!SplitTextCtor || typeof SplitTextCtor.create !== 'function') {
			initAttempts++;
			if (initAttempts < maxInitAttempts) {
				setTimeout(initTeamDescriptionReveal, 100);
			}
			return;
		}

		gsap.registerPlugin(ScrollTriggerPlugin);

		var split = SplitTextCtor.create(textEl, {
			type: 'chars',
			charsClass: 'page-team__description-char',
			aria: 'auto',
		});

		var chars = split.chars || [];
		applyCharColors(chars, 0);

		function setFillFromProgress(self) {
			applyCharColors(split.chars, fillProgressFromScrollProgress(self.progress));
		}

		var st = ScrollTriggerPlugin.create({
			trigger: introSection,
			start: 'bottom bottom',
			end: function() {
				var h = typeof window !== 'undefined' && window.innerHeight ? window.innerHeight : 800;
				return '+=' + Math.round(h * (PIN_SCROLL_VH / 100));
			},
			pin: true,
			pinSpacing: true,
			scrub: 0.15,
			anticipatePin: 1,
			invalidateOnRefresh: true,
			onUpdate: function(self) {
				setFillFromProgress(self);
			},
			onRefresh: function(self) {
				chars = split.chars;
				setFillFromProgress(self);
			},
			onLeave: function() {
				applyCharColors(split.chars, 1);
			},
			onLeaveBack: function() {
				applyCharColors(split.chars, 0);
			},
		});

		requestAnimationFrame(function() {
			if (st && typeof st.progress === 'number') {
				chars = split.chars;
				setFillFromProgress(st);
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initTeamDescriptionReveal);
	} else {
		initTeamDescriptionReveal();
	}
})();
